import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";

import { ReactComponent as DetailedIconWhite } from "../icons/Subject24White.svg";
import { ReactComponent as SimpleIconWhite } from "../icons/ShortText24White.svg";

import { ReactComponent as DetailedIconBlack } from "../icons/Subject24Black.svg";
import { ReactComponent as SimpleIconBlack } from "../icons/ShortText24Black.svg";

const StandardDetailedToggle = ({
  value,
  onChange,
  size = "small",
  standardValue = "standard",
  detailedValue = "detailed",
}) => {
  const isDetailed = value === detailedValue;

  return (
    <ButtonGroup size={size}>
      <Button
        variant={!isDetailed ? "contained" : "outlined"}
        onClick={() => onChange(standardValue)}
        title="Standard view"
        aria-label="Standard view"
      >
        {!isDetailed ? <SimpleIconWhite /> : <SimpleIconBlack />}
      </Button>
      <Button
        variant={isDetailed ? "contained" : "outlined"}
        onClick={() => onChange(detailedValue)}
        title="Detailed view"
        aria-label="Detailed view"
      >
        {isDetailed ? <DetailedIconWhite /> : <DetailedIconBlack />}
      </Button>
    </ButtonGroup>
  );
};

export default StandardDetailedToggle;
